import styled from 'styled-components';

const Spacer: any = styled.div`
  display: block;
  height: ${(props: { units: number }) => props.units * 4 + 'px'};
`;

Spacer.defaultProps = {
  units: 5,
};

export default Spacer;
